import { Link } from "react-router-dom";

export const SMSVerifiedRegistration = () => {
  return (
    <div className="w-full min-h-screen bg-white">
      <div className="flex flex-col min-h-[calc(100vh-72px)] p-4 sm:px-8">
        <div className="text-lg font-bold leading-normal tracking-tight mt-5">すでにSMS認証は完了しています</div>
        <div className=" mt-[10px]">
          <div className="text-black text-sm font-medium tracking-tight">
            SMS認証はすでに完了しています。連携した電話番号を変更したい場合はお問い合わせください。
          </div>
        </div>
        <Link to="/">
          <div className="text-primary font-noto-sans text-[16px] normal-case font-normal leading-[120%] tracking-[-0.04em] underline mt-[26px]">
            ホームにもどる
          </div>
        </Link>
      </div>
    </div>
  );
};
